exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dots-item[data-v-ae8cc22c] {\n  padding: 10px 5px;\n  color: #6d7d89;\n  line-height: 18px;\n  text-align: center;\n  border-radius: 20px;\n  box-shadow: 0 4px 10px rgba(44, 145, 179, 0.3);\n  cursor: pointer;\n  transition: color 100ms ease, background 100ms ease;\n}\n.dots-item[data-v-ae8cc22c]:not(.red):hover {\n  color: #fff;\n  background: #94aabb;\n}\n.dots-item.red[data-v-ae8cc22c] {\n  color: #e00c02;\n}\n.dots-item.red[data-v-ae8cc22c]:hover {\n  color: #fff;\n  background: #e00c02;\n}\n.dots-item[data-v-ae8cc22c]:not(:last-child) {\n  margin-bottom: 6px;\n}\n", ""]);

// exports
